import { useCallback } from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

export const useGetLoginMode = () => {
    const usernameEmailSwitcher = useAppSelector(prop('usernameEmailSwitcher'));

    return useCallback((userName) => {
        const emailRegexp = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

        return usernameEmailSwitcher && emailRegexp.test(userName) ? 'email' : 'userName';
    }, [usernameEmailSwitcher]);
};
